import axios from "axios";
import i18n from "../../i18n";

const actions = {
  bulkDeleteOperatingInstructions(context, ids) {
    return axios
      .post("operatingInstruction/bulk-delete", { ids })
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },

  bulkMoveOperatingInstructions(context, { ids, instructionCategory }) {
    return axios
      .post("operatingInstruction/bulk-move", { ids, instructionCategory })
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },

  createOperatingInstruction(context, value) {
    return axios
      .post("operatingInstruction", value)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("operatingInstructions.createdMessage", { name: r.data.name }),
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  deleteOperatingInstruction(context, val) {
    return axios
      .delete("operatingInstruction/" + val.id)
      .then(function (res) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("operatingInstructions.deletedMessage"),
        );
        return res;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  updateOperatingInstruction(context, value) {
    return axios
      .put("operatingInstruction/" + value.id, value)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("operatingInstructions.updatedMessage", { name: r.data.name }),
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  moveOperatingInstruction(context, { id, instructionCategory }) {
    return axios
      .put(`operatingInstruction/${id}`, { instructionCategory })
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("operatingInstructions.movedMessage", {
            name: r.data.name,
          }),
        );
        return r.data;
      })
      .catch((e) => {
        context.dispatch("triggerError", e);
        throw e;
      });
  },

  copyOperatingInstruction(context, id) {
    return axios
      .post("operatingInstruction/" + id + "/copy")
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("operatingInstructions.copiedMessage", { name: r.data.name }),
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getSingleOperatingInstruction(context, id) {
    return axios
      .get("operatingInstruction/" + id)
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getOperatingInstructions(context, { instructionCategoryId }) {
    return axios
      .get("operatingInstruction", {
        params: {
          instructionCategory: instructionCategoryId,
          populate: "operatingInstructionLabel",
        },
      })
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getPdfOperatingInstruction(context, id) {
    return axios
      .get("operatingInstruction/" + id + "/pdf")
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },
};

export default actions;
